import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { images } from '../../../Constants/ImageUrls';
import { getPathForBabyNames } from '../../../Utils/helper';
import { clickedSectionEvent } from '../instrumentation/instrumentation';

function MostPopuparNameEach(props) {
  const { data, index, detailPage } = props;
  const router = useRouter();
  const [clickEffect, setClickEffect] = useState('');
  const effectHandler = () => {
    setClickEffect('lowOpacity');
    clickedSectionEvent(
      true,
      'BABY NAMES BY RELIGION',
      undefined,
      `${data} Baby names`,
    );
  };

  return (
    <li onClick={effectHandler} className={clickEffect} key={index}>
      <Link
        href={{
          pathname: getPathForBabyNames('search', detailPage, ''),
          query: {
            religion: data,
            mostViewed: true,
            ...router.query,
          },
        }}
        passHref
        locale={false}
      >
        <span>{data} Baby names</span>
        <img src={images.arrowforward} alt="right-arrow" loading="lazy" />
      </Link>
    </li>
  );
}

export default MostPopuparNameEach;
